const NON_ALPHANUMERIC_REGEXP = /[^a-zA-ZáéíóúÁÉÍÓÚñÑ´\s.0-9]/g;

export const removeNonAlphanumerics = (string) => string.replace(NON_ALPHANUMERIC_REGEXP, '');
